import React from 'react';

import RecurringInvoices from '../pageComponents/RecurringInvoices';

const RecurringInvoicesPage = () => <RecurringInvoices />;

export default RecurringInvoicesPage;
